import React from 'react';
import styled from 'styled-components';
import { compose } from 'redux';
import NotificationSystem from 'react-notification-system';
import withHandlers from 'recompose/withHandlers';
import withContext from 'recompose/withContext';
import isObject from 'lodash/isObject';
import {
  func
} from 'prop-types';

const Container = styled.div`
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
`;
Container.displayName = 'Container';

let handlers;
export const Notifications = {
  warning: (...args) => handlers.warning()(...args),
  warn: (...args) => handlers.warn()(...args),
  success: (...args) => handlers.success()(...args),
  info: (...args) => handlers.info()(...args),
  error: (...args) => handlers.error()(...args),
};

export default compose(
  withHandlers(() => {
    let _ref;
    let createNotification = (level) => (title, message, options = {}) => {
      if (!_ref) {
        if (options.stopRecursion) {
          return;
        }
        return setTimeout(() => createNotification(level)(title, message, { ...options, stopRecursion: true }), 500);
      }
      
      if (isObject(message)) {
        options = message;
        message = title;
        message = undefined;
      } else if (!message) {
        message = title;
        title = undefined;
      }

      _ref.addNotification({
        title,
        message,
        level,
        ...options
      });
    };
    handlers = {
      registerRef: () => ref => _ref = ref,
      warning: () => createNotification('warning'),
      warn: () => createNotification('warning'),
      success: () => createNotification('success'),
      info: () => createNotification('info'),
      error: () => createNotification('error')
    };
    return handlers;
  }),
  withContext({
    warning: func,
    warn: func,
    success: func,
    info: func,
    error: func
  }, ({ warning, warn, success, info, error }) => ({
    warning, warn, success, info, error
  }))
)(({ children, registerRef }) => {
  return (
    <Container>
      {children}
      <NotificationSystem ref={registerRef} />
    </Container>
  );
})


// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsProvider.js